import i18next from 'i18next';
import { getDefaultCurrency } from 'store/state';

export interface IFormatCurrecyOptions {
  suffix?: string;
  fractionDigits?: number;
  length?: number;
  minimumFractionDigits?: number;
}

const formatNumberWithLocaleSeparators = (
  number: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number
) => {
  const isEnglish = i18next.language?.startsWith('en');
  let formatted = number
    .toLocaleString('en-US', {
      minimumFractionDigits,
      maximumFractionDigits,
    })
    .replaceAll(',', ' ');

  // PL uses comma as decimal separator; EN keeps the period.
  if (!isEnglish) {
    formatted = formatted.replace('.', ',');
  }

  return formatted;
};

export const formatCurrency = (number = 0, options?: IFormatCurrecyOptions) => {
  const currency = formatNumberWithLocaleSeparators(
    number,
    options?.minimumFractionDigits ?? options?.fractionDigits ?? 2,
    options?.fractionDigits ?? 2
  ).concat(
    ` ${options?.suffix?.trim() ?? getDefaultCurrency()?.currencyCode ?? ''}`
  );

  if (options?.length && currency.length < options.length) {
    const missingSpaces = options.length - currency.length;
    return `${'  '.repeat(missingSpaces)}${currency}`;
  }

  return currency;
};

export const formatCurrencyFull = (number = 0) => {
  const formatted = formatNumberWithLocaleSeparators(number, 2, 20);

  return `${formatted} ${getDefaultCurrency()?.currencyCode ?? ''}`;
};
